import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import '@fontsource/roboto-condensed/300.css';
import '@fontsource/roboto-condensed/700.css';
import '@fontsource/roboto-condensed/400.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './utils/AuthContext.tsx';
import { InstanceProvider } from './utils/InstaceContext.tsx';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <InstanceProvider>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </InstanceProvider>
    </AuthProvider>
  </React.StrictMode>
);
